<template>
  <div class="container-pay-code" :style="cssVars()">
    <div class="main">
      <div class="custom-nav-block" :style="`paddingTop:${topBarHeight}px`">
        <!-- Buy coins -->
        <van-nav-bar class="van-bar" :title="$t('lang.PayCode.k001')" left-arrow @click-left="goPrevious">
          <template #left>
            <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
          </template>
        </van-nav-bar>
      </div>
      <div class="third-pay-block">
        <iframe scrolling="yes" :src="url" frameborder="0" class="object"></iframe>
      </div>
      <div :style="`width:100%;height:${bottomBarHeight}px`"></div>
    </div>
  </div>
</template>

<script>
import { getBaseFeature } from '@/assets/style/variable'

export default {
  components: {},
  props: {},
  data() {
    const query = this.$route.query
    return {
      topBarHeight: 0,
      url: query.url || null,
    }
  },
  methods: {
    cssVars() {
      return { ...getBaseFeature() }
    },
  },
}
</script>
<style lang="scss" scoped>
.container-pay-code {
  width: 100%;
  height: 100vh;
  overflow: hidden !important;
  .main {
    position: relative;
    width: 100%;
    height: 100vh;
    padding: 0 0;
    display: flex;
    flex-direction: column;
    .third-pay-block {
      flex: 1;
      .object {
        width: 100%;
        height: 100%;
        overflow: hidden;
      }
      .object ::-webkit-scrollbar {
        width: 0px;
        height: 0px;
        background-color: transparent;
      }
    }
  }
}
::v-deep .van-nav-bar__title {
  color: #333333;
}
</style>
